import AnalyticsOutlinedIcon from '@mui/icons-material/AnalyticsOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import RateReviewOutlinedIcon from '@mui/icons-material/RateReviewOutlined';
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined';
import React from 'react';

import { UserRoleDto } from '@/api/generated';
import ProcessIcon from '@/assets/icons/ProcessIcon.tsx';
import { RouteEnum } from '@/layouts/routes/model/Route.model.ts';

export interface MenuItemModel {
  icon: React.JSX.Element;
  id: MenuItemType;
  roles?: UserRoleDto[];
  routes: RouteEnum[];
}

export type MenuItemType =
  | 'analysisRemarks'
  | 'experienceCompanies'
  | 'interviewSimulation'
  | 'meetings'
  | 'processes'
  | 'processTemplates'
  | 'statistics';

export const MENU_ITEMS: MenuItemModel[] = [
  {
    icon: <ProcessIcon />,
    id: 'processes',
    routes: [RouteEnum.PROCESSES, RouteEnum.PROCESS_DETAILS],
  },
  {
    icon: <RateReviewOutlinedIcon />,
    id: 'analysisRemarks',
    routes: [RouteEnum.ANALYSIS_REMARKS],
  },
  {
    icon: <VideocamOutlinedIcon />,
    id: 'meetings',
    routes: [RouteEnum.MEETINGS],
  },
  {
    icon: <AnalyticsOutlinedIcon />,
    id: 'statistics',
    roles: [UserRoleDto.Admin],
    routes: [RouteEnum.STATISTICS],
  },
  {
    icon: <BusinessOutlinedIcon />,
    id: 'experienceCompanies',
    roles: [UserRoleDto.Admin],
    routes: [RouteEnum.EXPERIENCE_COMPANIES],
  },
  {
    icon: <AssignmentOutlinedIcon />,
    id: 'processTemplates',
    roles: [UserRoleDto.Admin],
    routes: [RouteEnum.PROCESS_TEMPLATES],
  },
];
